/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  customButtonContainer: 'customButtonContainer_4426fda0',
  icon: 'icon_4426fda0',
  themeDarkAltColor: 'themeDarkAltColor_4426fda0',
  leftText: 'leftText_4426fda0',
  splitter: 'splitter_4426fda0',
  button: 'button_4426fda0',
  darkerBG: 'darkerBG_4426fda0',
};

export = styles;

loadStyles([{"rawString":".customButtonContainer_4426fda0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.icon_4426fda0{display:inline-block;font-family:FabricMDL2Icons;font-style:normal;font-weight:400;speak:none;font-size:14px;position:relative}.themeDarkAltColor_4426fda0{color:"},{"theme":"themeDarkAlt","defaultValue":"#106ebe"},{"rawString":"}.leftText_4426fda0{margin-left:6px;font-size:14px;font-weight:400;color:"},{"theme":"neutralPrimary","defaultValue":"#333333"},{"rawString":"}.splitter_4426fda0{font-size:14px;font-weight:400;color:"},{"theme":"neutralTertiary","defaultValue":"#a6a6a6"},{"rawString":";background:0 0;position:relative;top:-2px;height:40px}.button_4426fda0.ms-Button{height:40px;min-width:28px;padding:0 5px}.button_4426fda0:hover{background:initial}.darkerBG_4426fda0{background:#d0d0d0}"}]);
/* tslint:enable */